import app from 'flarum/forum/app';
import Model from 'flarum/common/Model';
import Badge from 'flarum/common/components/Badge';
import User from 'flarum/common/models/User';
import ItemList from 'flarum/common/utils/ItemList';
import computed from 'flarum/common/utils/computed';
import {AutomaticDiscussionOptions, FormLinkType, FormTemplate, FormType} from './JsonTypes';

export default class Form extends Model {
    seoId = Model.attribute<string>('seoId');
    link_type = Model.attribute<FormLinkType>('link_type');
    link_id = Model.attribute<string>('link_id');
    slug = Model.attribute<string>('slug');
    title = Model.attribute<string>('title');
    private_title = Model.attribute<string>('private_title');
    template = Model.attribute<FormTemplate | null>('template');
    accept_submissions = Model.attribute<boolean>('accept_submissions');
    allow_modification = Model.attribute<boolean>('allow_modification');
    max_submissions = Model.attribute<number>('max_submissions');
    submission_count = Model.attribute<number>('submission_count');
    send_confirmation_to_participants = Model.attribute<boolean>('send_confirmation_to_participants');
    notify_emails = Model.attribute<string>('notify_emails');
    web_confirmation_message = Model.attribute<string>('web_confirmation_message');
    confirmationMessageHtml = Model.attribute<string>('confirmationMessageHtml');
    email_confirmation_message = Model.attribute<string>('email_confirmation_message');
    email_notification_message = Model.attribute<string>('email_notification_message');
    email_confirmation_title = Model.attribute<string>('email_confirmation_title');
    email_notification_title = Model.attribute<string>('email_notification_title');
    automatic_discussion_options = Model.attribute<AutomaticDiscussionOptions | null>('automatic_discussion_options');
    permission_see_own = Model.attribute<string>('permission_see_own');
    permission_see_any = Model.attribute<string>('permission_see_any');
    permission_edit_own = Model.attribute<string>('permission_edit_own');
    permission_edit_any = Model.attribute<string>('permission_edit_any');
    show_on_creation = Model.attribute<boolean>('show_on_creation');
    isHidden = Model.attribute<boolean>('isHidden');

    user = Model.hasOne<User>('user');

    // Returns the generic type string used for translations
    type = computed<FormType>('link_type', ((link_type: FormLinkType): FormType => {
        if (link_type === 'groups') {
            return 'user';
        }

        if (link_type === 'tags') {
            return 'discussion';
        }

        return 'standalone';
    }) as any);

    isAutoLink = computed<boolean>('type', 'automatic_discussion_options', ((type: FormType, options: AutomaticDiscussionOptions | null) => {
        return type === 'discussion' &&
            options &&
            options.enabled;
    }) as any);

    badges() {
        const items = new ItemList();

        if (this.isHidden()) {
            items.add('hidden', Badge.component({
                type: 'hidden',
                icon: 'fas fa-trash',
                label: app.translator.trans('kilowhat-formulaire.forum.badge.hidden'),
            }));
        }

        return items;
    }

    apiEndpoint() {
        return '/formulaire/forms' + (this.exists ? '/' + (this.data as any).id : '');
    }
}
